import Signal from './Signal'

export default class Scroll
{
    constructor({ target = window })
    {
        this.current = 0
        this.target = target

        this._onScroll = this._onScroll.bind(this)
        
        this.isScrolling = false
        this.onScrolled = new Signal()

        this.init()
    }

    init()
    {
        this.dispose()
        this.target.addEventListener('scroll', this._onScroll)
    }

    dispose()
    {
        this.target.removeEventListener('scroll', this._onScroll)
    }

    _onScroll()
    {
        this.current = window.scrollY
        cancelAnimationFrame(this._raf)
        this._raf = window.requestAnimationFrame(function() {

        })
    }
}
